module.exports = __webpack_public_path__ + "static/paypal1-e343d0934c36f0936d3a3c00ef1b8ccc.png";